// Vite entrypoint for blog index and article pages
import '../js/shared/fonts.ts'
import { enforcePreferredLocale } from '../js/shared/auth-locale-redirect.ts'
enforcePreferredLocale()
import { initAppsignal } from '../js/shared/appsignal.ts'
initAppsignal()
import '../css/style.css'
import '../js/components'
// Turbo only drives <turbo-frame>s (Drive is off), and of the blog pages only
// the index renders one. A static import cost every article 89 kB (25 kB
// gzipped) of script that never ran.
if (document.querySelector('turbo-frame')) void import('../js/shared/turbo.ts')
import '../css/blog.css'
import '../css/blog-blueprint.css'
import { initI18n } from '../js/shared/i18n.ts'
import { initBlog } from '../js/pages/blog'
import { initFeedback } from '../js/pages/feedback.ts'
import { initSearch } from '../js/shared/search.ts'

document.addEventListener('DOMContentLoaded', async () => {
  await initI18n()
  initSearch()
  initBlog()
  initFeedback()
})
